export enum PackPermission {
  READ_ONLY = 'read-only',
  ADMIN = 'admin',
  COLLABORATION = 'collaboration',
  OWNER = 'owner',
}
